export default __webpack_public_path__ + "static/media/cp_geo_do.112f9da2.svg";